module.exports = __webpack_public_path__ + "static/media/Document1.c0fb60d0.svg";